import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from './instructions/instructions.component';
import { VendorService } from './shared/vendor.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { ProgressBarService } from './shared/progress-bar.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'FCReferrals';
  payorkey = 0;
  headerHtml: any;
  isValidUrl = true;
  isCheckingUrl = true;
  securityCode: string = '';
  currentActivity: string = 'PartyInformation';
  showProgressBar: boolean = true;

  private readonly skipList = new Set<string>([
    'final','submit','summary','particpant','validateparticipant','service',
    'questions','provider','member','involvedparties', 'additionalinvolvedparties','witness',
    'nonenumeratedprovider','nonenumeratedorganization','nonenumeratedindividual',
    'user','userdetails','user-details'
  ]);

  private navSub?: Subscription;
  submitPartyColor: string = '';
  referralColor: string = '';
  involvedPartyColor: string = '';
  questionColor: string = '';
  submitReferralColor: string = '';
  submitPartyBgColor: string = '';
  referralBgColor: string = '';
  involvedPartyBgColor: string = '';
  questionBgColor: string = '';
  submitReferralBgColor: string = '';
  referralLineColor: string = '';
  involvedPartyLineColor: string = '';
  questionLineColor: string = '';
  submitReferralLineColor: string = '';
  submitPartyNumColor: string = '';
  referralNumColor: string = '';
  involvedPartyNumColor: string = '';
  questionNumColor: string = '';
  submitReferralNumColor: string = '';

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private vendorService: VendorService,
    private sanitizer: DomSanitizer,
    private cdref: ChangeDetectorRef,
    private progressBarService: ProgressBarService
  ) {}

  ngOnInit(): void {
    this.setHeader();
    this.navSub = this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) this.setHeader();
    });

    this.setProgressBar();
    this.progressBarService.getData().subscribe((data) => {
      if(data) {
        this.setProgressBar();
      }
    })
  }

  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
  }

  openInstruction() {
    this.modalService.open(InstructionsComponent);
  }

  setHeader() {
    this.isCheckingUrl = true;
    const url = this.router.url.split('?')[0].split('#')[0];
    const firstSeg = url.replace(/^\/+/, '').split('/')[0] || '';
    this.securityCode = firstSeg;
    if (!firstSeg) {
      this.isValidUrl = false;
      this.isCheckingUrl = false;
      this.headerHtml = '';
      return;
    }
    const loadHeaderByPayor = (payorId: number) => {
      this.vendorService.getLeadHeaders(payorId).subscribe((leadResult) => {
        if (leadResult?.HeaderText) {
          const headerHtmlText = leadResult.HeaderText
            .replace(/<img /g, '<img title="Header Image" alt="Header Image" ');
          this.headerHtml = this.sanitizer.bypassSecurityTrustHtml(headerHtmlText);
        } else {
          this.headerHtml = '';
        }
        this.isCheckingUrl = false;
      }, _ => {
        this.headerHtml = '';
        this.isCheckingUrl = false;
      });
    };
    if (this.skipList.has(firstSeg.toLowerCase())) {
      this.isValidUrl = true;
      const sessionPayorkey = parseInt(sessionStorage.getItem('payorkey') ?? '0', 10);
      if (sessionPayorkey) {
        this.payorkey = sessionPayorkey;
        loadHeaderByPayor(this.payorkey);
      } else {
        this.isCheckingUrl = false;
      }
      return;
    }
    const looksLikeCode = /^[A-Za-z0-9_-]{6,}$/.test(firstSeg);
    if (!looksLikeCode) {
      this.isValidUrl = true;
      this.isCheckingUrl = false;
      return;
    }
    this.vendorService.verifyReferralCode(this.securityCode).subscribe(confirm => {
      if (confirm) {
        this.isValidUrl = true;
        this.vendorService.getPayorIdByCode(this.securityCode).subscribe(result => {
          if (result != null) {
            this.payorkey = result;
            sessionStorage.setItem('payorkey', String(this.payorkey));
            loadHeaderByPayor(this.payorkey);
          } else {
            this.isCheckingUrl = false;
             this.isValidUrl = false;
          }
        }, _ => this.isCheckingUrl = false);
      } else {
        this.isValidUrl = false;
        this.isCheckingUrl = false;
      }
    }, _ => {
      this.isValidUrl = false;
      this.isCheckingUrl = false;
    });
  }

  setProgressBar() {
    let primaryColor = '';
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        primaryColor = colorFromStorage ? colorFromStorage.toString() : 'rgb(0, 134, 113)';
        document.documentElement.style.setProperty('--primary-color', primaryColor);
      }
      
      let currentUrl = window.location.hash;

      this.submitPartyColor = '#757575';
      this.submitPartyNumColor = '#757575';
      this.submitPartyBgColor = 'lightgray';
      this.referralColor = '#757575';
      this.referralNumColor = '#757575';
      this.referralBgColor = 'lightgray';
      this.referralLineColor = 'lightgray';
      this.involvedPartyColor = '#757575';
      this.involvedPartyNumColor = '#757575';
      this.involvedPartyBgColor = 'lightgray';
      this.involvedPartyLineColor = 'lightgray';
      this.questionColor = '#757575';
      this.questionNumColor = '#757575';
      this.questionBgColor = 'lightgray';
      this.questionLineColor = 'lightgray';
      this.submitReferralColor = '#757575';
      this.submitReferralNumColor = '#757575';
      this.submitReferralBgColor = 'lightgray';
      this.submitReferralLineColor = 'lightgray';
          
      this.setFormCompletionColor(currentUrl, primaryColor);

      this.cdref.detectChanges();
    });

  }

  setFormCompletionColor(currentUrl: string, primaryColor: string) {

    let userDetailsFormValid = window.sessionStorage.getItem("UserDetailsFormValid") != null;
    let referralFormValid = window.sessionStorage.getItem("ReferralFormValid") != null;
    let involvedPartyFormValid = window.sessionStorage.getItem("InvolvedPartyFormValid") != null;
    let additionalInvolvedPartyFormValid = window.sessionStorage.getItem("AdditionalInvolvedPartyFormValid") != null;
    let questionsFormValid = window.sessionStorage.getItem("QuestionsFormValid") != null;

    if(currentUrl.includes('witness')) {
      this.showProgressBar = true;
      this.referralColor = 'black';
      this.referralNumColor = 'white';
      this.referralBgColor = 'black';
      this.referralLineColor = 'lightgray';
      
      if(userDetailsFormValid) {
        this.submitPartyColor = primaryColor;
        this.submitPartyNumColor = 'white';
        this.submitPartyBgColor = primaryColor;
      }

      if(questionsFormValid) {
        this.questionColor = primaryColor;
        this.questionNumColor = 'white';
        this.questionBgColor = primaryColor;
        this.questionLineColor = primaryColor;
      }

      if(involvedPartyFormValid && additionalInvolvedPartyFormValid) {
        this.involvedPartyColor = primaryColor;
        this.involvedPartyNumColor = 'white';
        this.involvedPartyBgColor = primaryColor;
        this.involvedPartyLineColor = primaryColor;
      }
    }
    else if(currentUrl.includes('involvedParties') || currentUrl.includes('additionalInvolvedParties')) {
      this.showProgressBar = true;
      this.involvedPartyColor = 'black';
      this.involvedPartyNumColor = 'white';
      this.involvedPartyBgColor = 'black';
      this.involvedPartyLineColor = 'lightgray';
      
      if(userDetailsFormValid) {
        this.submitPartyColor = primaryColor;
        this.submitPartyNumColor = 'white';
        this.submitPartyBgColor = primaryColor;
      }

      if(referralFormValid) {
        this.referralColor = primaryColor;
        this.referralNumColor = 'white';
        this.referralBgColor = primaryColor;
        this.referralLineColor = primaryColor;
      }

      if(questionsFormValid) {
        this.questionColor = primaryColor;
        this.questionNumColor = 'white';
        this.questionBgColor = primaryColor;
        this.questionLineColor = primaryColor;
      }
    }
    else if(currentUrl.includes('questions')) {
      this.showProgressBar = true;
      this.questionColor = 'black';
      this.questionNumColor = 'white';
      this.questionBgColor = 'black';
      this.questionLineColor = 'lightgray';

      if(userDetailsFormValid) {
        this.submitPartyColor = primaryColor;
        this.submitPartyNumColor = 'white';
        this.submitPartyBgColor = primaryColor;
      }

      if(referralFormValid) {
        this.referralColor = primaryColor;
        this.referralNumColor = 'white';
        this.referralBgColor = primaryColor;
        this.referralLineColor = primaryColor;
      }
      if(involvedPartyFormValid && additionalInvolvedPartyFormValid) {
        this.involvedPartyColor = primaryColor;
        this.involvedPartyNumColor = 'white';
        this.involvedPartyBgColor = primaryColor;
        this.involvedPartyLineColor = primaryColor;
      }
    }
    else if(currentUrl.includes('submit')) {
      this.showProgressBar = true;
      this.submitReferralColor = 'black';
      this.submitReferralNumColor = 'white';
      this.submitReferralBgColor = 'black';
      this.submitReferralLineColor = 'lightgray';
      
      if(userDetailsFormValid) {
        this.submitPartyColor = primaryColor;
        this.submitPartyNumColor = 'white';
        this.submitPartyBgColor = primaryColor;
      }

      if(referralFormValid) {
        this.referralColor = primaryColor;
        this.referralNumColor = 'white';
        this.referralBgColor = primaryColor;
        this.referralLineColor = primaryColor;
      }

      if(questionsFormValid) {
        this.questionColor = primaryColor;
        this.questionNumColor = 'white';
        this.questionBgColor = primaryColor;
        this.questionLineColor = primaryColor;
      }
      if(involvedPartyFormValid && additionalInvolvedPartyFormValid) {
        this.involvedPartyColor = primaryColor;
        this.involvedPartyNumColor = 'white';
        this.involvedPartyBgColor = primaryColor;
        this.involvedPartyLineColor = primaryColor;
      }
    }
    else if(currentUrl.includes('final')) {
      this.showProgressBar = false;
    }
    else {
      this.showProgressBar = true;
      this.submitPartyColor = 'black';
      this.submitPartyNumColor = 'white';
      this.submitPartyBgColor = 'black';
      
      if(referralFormValid) {
        this.referralColor = primaryColor;
        this.referralNumColor = 'white';
        this.referralBgColor = primaryColor;
        this.referralLineColor = primaryColor;
      }
      
      if(questionsFormValid) {
        this.questionColor = primaryColor;
        this.questionNumColor = 'white';
        this.questionBgColor = primaryColor;
        this.questionLineColor = primaryColor;
      }
      if(involvedPartyFormValid && additionalInvolvedPartyFormValid) {
        this.involvedPartyColor = primaryColor;
        this.involvedPartyNumColor = 'white';
        this.involvedPartyBgColor = primaryColor;
        this.involvedPartyLineColor = primaryColor;
      }
    }
  }


}
